import React from 'react';
import {
  BoldIcon,
  ItalicIcon,
  UnderlineIcon,
} from '@heroicons/react/24/outline';
import { FONT_FAMILIES, FONT_SIZES, LINE_SPACING } from '../constants';
import {
  AlignLeftIcon,
  AlignCenterIcon,
  AlignRightIcon,
  AlignTopIcon,
  AlignMiddleIcon,
  AlignBottomIcon,
} from './AlignmentIcons';

export default function FormatControls({ style, onStyleChange }) {
  const toggleStyle = (property, value) => {
    onStyleChange({
      [property]: style[property] === value ? undefined : value,
    });
  };

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-4">
        <select
          value={style.fontFamily}
          onChange={(e) => onStyleChange({ fontFamily: e.target.value })}
          className="px-3 py-1.5 border rounded"
        >
          {FONT_FAMILIES.map((font) => (
            <option key={font.value} value={font.value}>
              {font.label}
            </option>
          ))}
        </select>

        <select
          value={style.fontSize}
          onChange={(e) => onStyleChange({ fontSize: e.target.value })}
          className="px-3 py-1.5 border rounded"
        >
          {FONT_SIZES.map((size) => (
            <option key={size.value} value={size.value}>
              {size.label}
            </option>
          ))}
        </select>

        <select
          value={style.lineHeight || '1'}
          onChange={(e) => onStyleChange({ lineHeight: e.target.value })}
          className="px-3 py-1.5 border rounded"
        >
          {LINE_SPACING.map((spacing) => (
            <option key={spacing.value} value={spacing.value}>
              {spacing.label}
            </option>
          ))}
        </select>

        <input
          type="color"
          value={style.color}
          onChange={(e) => onStyleChange({ color: e.target.value })}
          className="w-8 h-8 p-0.5 border rounded cursor-pointer"
        />

        <div className="flex items-center gap-2">
          <button
            onClick={() => toggleStyle('fontWeight', 'bold')}
            disabled={style.fontFamily === 'Bangers'}
            title={style.fontFamily === 'Bangers' ? 'Bold not supported for Bangers font' : 'Bold'}
            className={`p-2 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed ${
              style.fontWeight === 'bold' ? 'bg-gray-200' : ''
            }`}
          >
            <BoldIcon className="h-4 w-4" />
          </button>

          <button
            onClick={() => toggleStyle('fontStyle', 'italic')}
            disabled={style.fontFamily === 'Bangers'}
            title={style.fontFamily === 'Bangers' ? 'Italic not supported for Bangers font' : 'Italic'}
            className={`p-2 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed ${
              style.fontStyle === 'italic' ? 'bg-gray-200' : ''
            }`}
          >
            <ItalicIcon className="h-4 w-4" />
          </button>

          <button
            onClick={() => toggleStyle('textDecoration', 'underline')}
            className={`p-2 rounded hover:bg-gray-100 ${
              style.textDecoration === 'underline' ? 'bg-gray-200' : ''
            }`}
          >
            <UnderlineIcon className="h-4 w-4" />
          </button>
        </div>
      </div>

      <div className="flex items-center gap-4">
        {/* Horizontal Alignment */}
        <div className="flex items-center gap-2">
          <button
            onClick={() => onStyleChange({ textAlign: 'left' })}
            className={`p-2 rounded hover:bg-gray-100 ${
              style.textAlign === 'left' ? 'bg-gray-200' : ''
            }`}
            title="Align Left"
          >
            <AlignLeftIcon />
          </button>

          <button
            onClick={() => onStyleChange({ textAlign: 'center' })}
            className={`p-2 rounded hover:bg-gray-100 ${
              style.textAlign === 'center' ? 'bg-gray-200' : ''
            }`}
            title="Align Center"
          >
            <AlignCenterIcon />
          </button>

          <button
            onClick={() => onStyleChange({ textAlign: 'right' })}
            className={`p-2 rounded hover:bg-gray-100 ${
              style.textAlign === 'right' ? 'bg-gray-200' : ''
            }`}
            title="Align Right"
          >
            <AlignRightIcon />
          </button>
        </div>
        <div className="h-6 w-px bg-gray-200" /> {/* Vertical divider */}
        {/* Vertical Alignment */}
        <div className="flex items-center gap-2">
          <button
            onClick={() => onStyleChange({ verticalAlign: 'top' })}
            className={`p-2 rounded hover:bg-gray-100 ${
              !style.verticalAlign || style.verticalAlign === 'top'
                ? 'bg-gray-200'
                : ''
            }`}
            title="Align Top"
          >
            <AlignTopIcon />
          </button>

          <button
            onClick={() => onStyleChange({ verticalAlign: 'middle' })}
            className={`p-2 rounded hover:bg-gray-100 ${
              style.verticalAlign === 'middle' ? 'bg-gray-200' : ''
            }`}
            title="Align Middle"
          >
            <AlignMiddleIcon />
          </button>

          <button
            onClick={() => onStyleChange({ verticalAlign: 'bottom' })}
            className={`p-2 rounded hover:bg-gray-100 ${
              style.verticalAlign === 'bottom' ? 'bg-gray-200' : ''
            }`}
            title="Align Bottom"
          >
            <AlignBottomIcon />
          </button>
        </div>
      </div>
    </div>
  );
}
